
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  position:relative;
}
  :host:before{
    content:'';
    position:absolute;
    top:0;
    left:calc((100vw - 100%) / -2);
    width:100vw;
    height:1px;
    background:transparent;
    background:var(--secondary-border-color, transparent);
  }

ul{
  list-style:none;

  margin:var(--sic-secondary-menu--default--margin);

  margin:var(
    --sic-secondary-menu--margin,
    var(--sic-secondary-menu--default--margin)
  );

  padding:var(--sic-secondary-menu--default--padding);

  padding:var(
    --sic-secondary-menu--padding,
    var(--sic-secondary-menu--default--padding)
  );

  display:var(--sic-secondary-menu--default--display);

  display:var(
    --sic-secondary-menu----sic-secondary-menu--default--display,
    var(--sic-secondary-menu--default--display)
  );

  flex-direction:var(--sic-secondary-menu--default--flex-direction);

  flex-direction:var(
    --sic-secondary-menu--flex-direction,
    var(--sic-secondary-menu--default--flex-direction)
  );

  flex-wrap:var(--sic-secondary-menu--default--flex-wrap);

  flex-wrap:var(
    --sic-secondary-menu--flex-wrap,
    var(--sic-secondary-menu--default--flex-wrap)
  );

  justify-content:var(--sic-secondary-menu--default--justify-content);

  justify-content:var(
    --sic-secondary-menu--justify-content,
    var(--sic-secondary-menu--default--justify-content)
  );

  align-items:var(--sic-secondary-menu--default--align-items);

  align-items:var(
    --sic-secondary-menu--align-items,
    var(--sic-secondary-menu--default--align-items)
  );

  font-family:var(--sic-secondary-menu--default--font-family);

  font-family:var(
    --sic-secondary-menu--font-family,
    var(--sic-secondary-menu--default--font-family)
  );

  font-size:var(--sic-secondary-menu--default--font-size);

  font-size:var(
    --sic-secondary-menu--font-size,
    var(--sic-secondary-menu--default--font-size)
  );

  font-weight:var(--sic-secondary-menu--default--font-weight);

  font-weight:var(
    --sic-secondary-menu--font-weight,
    var(--sic-secondary-menu--default--font-weight)
  );

  line-height:var(--sic-secondary-menu--default--line-height);

  line-height:var(
    --sic-secondary-menu--line-height,
    var(--sic-secondary-menu--default--line-height)
  );

  gap:var(--sic-secondary-menu--default--gap);

  gap:var(--sic-secondary-menu--gap, var(--sic-secondary-menu--default--gap));
}

li{
  padding:var(--sic-secondary-menu-item--default--padding);
  padding:var(
    --sic-secondary-menu-item--padding,
    var(--sic-secondary-menu-item--default--padding)
  );
  margin:var(--sic-secondary-menu-item--default--margin);
  margin:var(
    --sic-secondary-menu-item--margin,
    var(--sic-secondary-menu-item--default--margin)
  );
}

a{
  display:inline-block;
  text-decoration:none;
  color:red;

  border-top-width:var(--sic-secondary-menu-item-link--default--border-top-width);

  border-top-width:var(
    --sic-secondary-menu-item-link--border-top-width,
    var(--sic-secondary-menu-item-link--default--border-top-width)
  );

  border-right-width:var(--sic-secondary-menu-item-link--default--border-right-width);

  border-right-width:var(
    --sic-secondary-menu-item-link--border-right-width,
    var(--sic-secondary-menu-item-link--default--border-right-width)
  );

  border-bottom-width:var(--sic-secondary-menu-item-link--default--border-bottom-width);

  border-bottom-width:var(
    --sic-secondary-menu-item-link--border-bottom-width,
    var(--sic-secondary-menu-item-link--default--border-bottom-width)
  );

  border-left-width:var(--sic-secondary-menu-item-link--default--border-left-width);

  border-left-width:var(
    --sic-secondary-menu-item-link--border-left-width,
    var(--sic-secondary-menu-item-link--default--border-left-width)
  );

  border-color:var(--sic-secondary-menu-item-link--default--border-color);

  border-color:var(
    --sic-secondary-menu-item-link--border-color,
    var(--sic-secondary-menu-item-link--default--border-color)
  );

  padding:var(--sic-secondary-menu-item-link--default--padding);

  padding:var(
    --sic-secondary-menu-item-link--padding,
    var(--sic-secondary-menu-item-link--default--padding)
  );
  margin:var(--sic-secondary-menu-item-link--default--margin);
  margin:var(
    --sic-secondary-menu-item-link--margin,
    var(--sic-secondary-menu-item-link--default--margin)
  );

  color:var(--sic-secondary-menu-item-link--default--color);

  color:var(
    --sic-secondary-menu-item-link--color,
    var(--sic-secondary-menu-item-link--default--color)
  );

  background:var(--sic-secondary-menu-item-link--default--background);

  background:var(
    --sic-secondary-menu-item-link--background,
    var(--sic-secondary-menu-item-link--default--background)
  );
}

a:hover{
    border-top-width:var(--sic-secondary-menu-item-link--default--border-top-width--hover);
    border-top-width:var(
      --sic-secondary-menu-item-link--border-top-width--hover,
      var(--sic-secondary-menu-item-link--default--border-top-width--hover)
    );

    border-right-width:var(--sic-secondary-menu-item-link--default--border-right-width--hover);

    border-right-width:var(
      --sic-secondary-menu-item-link--border-right-width--hover,
      var(--sic-secondary-menu-item-link--default--border-right-width--hover)
    );

    border-bottom-width:var(--sic-secondary-menu-item-link--default--border-bottom-width--hover);

    border-bottom-width:var(
      --sic-secondary-menu-item-link--border-bottom-width--hover,
      var(--sic-secondary-menu-item-link--default--border-bottom-width--hover)
    );

    border-left-width:var(--sic-secondary-menu-item-link--default--border-left-width--hover);

    border-left-width:var(
      --sic-secondary-menu-item-link--border-left-width--hover,
      var(--sic-secondary-menu-item-link--default--border-left-width--hover)
    );

    border-color:var(--sic-secondary-menu-item-link--default--border-color--hover);

    border-color:var(
      --sic-secondary-menu-item-link--border-color--hover,
      var(--sic-secondary-menu-item-link--default--border-color--hover)
    );

    color:var(--sic-secondary-menu-item-link--default--color--hover);

    color:var(
      --sic-secondary-menu-item-link--color--hover,
      var(--sic-secondary-menu-item-link--default--color--hover)
    );

    background:var(--sic-secondary-menu-item-link--default--background--hover);

    background:var(
      --sic-secondary-menu-item-link--background--hover,
      var(--sic-secondary-menu-item-link--default--background--hover)
    );
  }

a:active,
  a.is-active,
  a.active-trail{
    border-top-width:var(--sic-secondary-menu-item-link--default--border-top-width--active);
    border-top-width:var(
      --sic-secondary-menu-item-link--border-top-width--active,
      var(--sic-secondary-menu-item-link--default--border-top-width--active)
    );

    border-right-width:var(--sic-secondary-menu-item-link--default--border-right-width--active);

    border-right-width:var(
      --sic-secondary-menu-item-link--border-right-width--active,
      var(--sic-secondary-menu-item-link--default--border-right-width--active)
    );

    border-bottom-width:var(--sic-secondary-menu-item-link--default--border-bottom-width--active);

    border-bottom-width:var(
      --sic-secondary-menu-item-link--border-bottom-width--active,
      var(--sic-secondary-menu-item-link--default--border-bottom-width--active)
    );

    border-left-width:var(--sic-secondary-menu-item-link--default--border-left-width--active);

    border-left-width:var(
      --sic-secondary-menu-item-link--border-left-width--active,
      var(--sic-secondary-menu-item-link--default--border-left-width--active)
    );

    border-color:var(--sic-secondary-menu-item-link--default--border-color--active);

    border-color:var(
      --sic-secondary-menu-item-link--border-color--active,
      var(--sic-secondary-menu-item-link--default--border-color--active)
    );

    color:var(--sic-secondary-menu-item-link--default--color--active);

    color:var(
      --sic-secondary-menu-item-link--color--active,
      var(--sic-secondary-menu-item-link--default--color--active)
    );

    background:var(--sic-secondary-menu-item-link--default--background--active);

    background:var(
      --sic-secondary-menu-item-link--background--active,
      var(--sic-secondary-menu-item-link--default--background--active)
    );
  }

a:focus{
    border-top-width:var(--sic-secondary-menu-item-link--default--border-top-width--focus);
    border-top-width:var(
      --sic-secondary-menu-item-link--border-top-width--focus,
      var(--sic-secondary-menu-item-link--default--border-top-width--focus)
    );

    border-right-width:var(--sic-secondary-menu-item-link--default--border-right-width--focus);

    border-right-width:var(
      --sic-secondary-menu-item-link--border-right-width--focus,
      var(--sic-secondary-menu-item-link--default--border-right-width--focus)
    );

    border-bottom-width:var(--sic-secondary-menu-item-link--default--border-bottom-width--focus);

    border-bottom-width:var(
      --sic-secondary-menu-item-link--border-bottom-width--focus,
      var(--sic-secondary-menu-item-link--default--border-bottom-width--focus)
    );

    border-left-width:var(--sic-secondary-menu-item-link--default--border-left-width--focus);

    border-left-width:var(
      --sic-secondary-menu-item-link--border-left-width--focus,
      var(--sic-secondary-menu-item-link--default--border-left-width--focus)
    );

    border-color:var(--sic-secondary-menu-item-link--default--border-color--focus);

    border-color:var(
      --sic-secondary-menu-item-link--border-color--focus,
      var(--sic-secondary-menu-item-link--default--border-color--focus)
    );

    color:var(--sic-secondary-menu-item-link--default--color--focus);

    color:var(
      --sic-secondary-menu-item-link--color--focus,
      var(--sic-secondary-menu-item-link--default--color--focus)
    );

    background:var(--sic-secondary-menu-item-link--default--background--focus);

    background:var(
      --sic-secondary-menu-item-link--background--focus,
      var(--sic-secondary-menu-item-link--default--background--focus)
    );
  }
`;